import React from 'react';
import { useDrop } from 'react-dnd';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Spinner } from 'react-bootstrap';

import { Types } from '../Types/';
import { setQuestionType } from '../../../../_actions/question-library.action';
import TypeFactory from './TypeFactory';
import Empty from './Types/Empty';

import './styles.css';

const CanvasContainer = ({ question = null, isLoading, dispatch }) => {
  const [{ canDrop }, drop] = useDrop({
    accept: Types,
    drop: (item, monitor) => {
      if (monitor.didDrop()) {
        return;
      }

      dispatch(setQuestionType(item.type));
    },
    collect: (monitor) => ({
      canDrop: monitor.canDrop() && monitor.isOver({ shallow: true }),
    })
  });

  const canDropStyle = classNames('question-canvas-body', 'p-3', {
    active: canDrop
  });

  return (
    <div className="question-canvas">
      <div className="question-canvas-header col mb-2" style={{ borderBottom: '4px solid #1AB2E9' }}>
        <h5>Canvas</h5>
      </div>

      <div ref={drop} className={canDropStyle}>
        {isLoading &&
          <Spinner animation="border" role="status">
            <span className="sr-only">Loading...</span>
          </Spinner>
        }

        {!isLoading && question &&
          TypeFactory(question)
        }

        {!isLoading && !question &&
          <Empty />
        }
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    isLoading: state.questionLibrary.isLoading,
    question: state.questionLibrary.current
  }
}

const Canvas = connect(mapStateToProps)(CanvasContainer);

export default Canvas;
